export enum Languages{
    English = 'en',
    German = 'de',
    Chinese = 'ch',
}